import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Perimeter } from 'src/app/utils/interfaces/new/perimeter.interface';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class PerimetersService {

  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  private isMock = environment.mock;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response'
  };

  private apiUri = environment.basePath + '/user/perimeters';

  constructor(
    private _http: HttpClient,
    private _snack: SnackbarService
  ) { }

  public async findPerimeters(myPerimeters: string = 'delegant'): Promise<Perimeter[]> {
    try {
      const res = await this._http.get(this.apiUri+`?role=${myPerimeters}`, this.httpOptions).toPromise();
      const perimeters = res.body as Perimeter[];
      return perimeters;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async updatePerimeters(perimeters: Perimeter[]) {
    try {
      const res = await this._http.put(this.apiUri, perimeters, this.httpOptions).toPromise();
      this._snack.openSnackBar("Périmètres sauvegardés");
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

}
